import { Address } from '@anyx/shared-utils';

export const FirstNameDisplay = ({ address }: { address: Address; hasPrevious: boolean }) => {
  return address?.firstName ? <span>{address?.firstName}</span> : null;
};
